import styled from "@emotion/styled";

const FontFace = styled.div`
  @font-face {
    font-family: "inter";
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src:
      local("Inter"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-400-normal.woff",
          import.meta.url,
        ).href})
        format("woff"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-400-normal.woff2",
          import.meta.url,
        ).href})
        format("woff2");
  }
  @font-face {
    font-family: "inter";
    font-style: normal;
    font-display: swap;
    font-weight: 500;
    src:
      local("Inter"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-500-normal.woff",
          import.meta.url,
        ).href})
        format("woff"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-500-normal.woff2",
          import.meta.url,
        ).href})
        format("woff2");
  }
  @font-face {
    font-family: "inter";
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src:
      local("Inter"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-600-normal.woff",
          import.meta.url,
        ).href})
        format("woff"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-600-normal.woff2",
          import.meta.url,
        ).href})
        format("woff2");
  }
  @font-face {
    font-family: "inter";
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src:
      local("Inter"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-700-normal.woff",
          import.meta.url,
        ).href})
        format("woff"),
      url(${new URL(
          "@fontsource/inter/files/inter-latin-700-normal.woff2",
          import.meta.url,
        ).href})
        format("woff2");
  }
`;

export default FontFace;
